import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { IAnswerAll } from '../models';

export function useGetChatFlowResult() {
  const id = useAppSelector(state => state.aiAgentReducer.openResultDrawer.id);

  return useQuery<IAnswerAll>({
    queryKey: ['chatflow-result', id],
    queryFn: async () => {
      const res = await $api.get(`/v1/chat-flow/answer/${id}`);

      return res.data.data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: !!id
  });
}
